module.exports = __webpack_public_path__ + "static/hero-bg-video-38879b94b17bda5aa24ae410ed12f877.mp4";